import defineMessages from "../../../../common/helpers/defineMessages";

const messages = defineMessages({
    playTest: {
        id: "planCard.playTest",
    },
    playShareTest: {
        id: "planCard.playShareTest",
    },
    edit: {
        id: "planCard.edit",
    },
    view: {
        id: "plan.view",
    },
    logInToGadgets: {
        id: "plan.logInToGadgets",
    },
    homeworkPlay: {
        id: "homework.play",
    },
    profileToGadgets: {
        id: "planCard.profileToGadgets",
    },
    originalPlan: {
        id: "planCard.originalPlan",
    },
    moderate: {
        id: "planCard.moderate",
    },
});

export default messages;
